export const siderbarItem = [
  {
    icon: 'mdi-view-dashboard',
    trans: 'sidebar.dashboard.name',
    router: {
      name: 'dashboard',
    },
    scopes: ['dashboard'],
  },
  {
    icon: 'mdi-account',
    trans: 'sidebar.users.name',
    router: {
      name: 'users',
    },
    scopes: ['user-management'],
  },
  {
    icon: 'mdi-map',
    trans: 'sidebar.map-preview.name',
    router: {
      name: 'map',
    },
    scopes: ['access:editor', 'access:admin'],
  },
  {
    icon: 'mdi-share-variant',
    trans: 'sidebar.map-share.name',
    router: {
      name: 'map-share-list',
    },
    scopes: ['access:editor', 'access:admin'],
  },
  {
    icon: 'mdi-map',
    trans: 'sidebar.basemap.name',
    router: {
      name: 'basemaps',
    },
    scopes: ['access:editor', 'access:admin'],
  },
  {
    icon: 'mdi-folder',
    trans: 'sidebar.workspace.name',
    router: {
      name: 'workspaces',
    },
    scopes: ['access:editor'],
  },
  {
    icon: 'mdi-layers',
    trans: 'sidebar.layer.name',
    router: {
      name: 'layers',
    },
    scopes: ['access:editor'],
  },
  // {
  //   icon: 'mdi-map',
  //   trans: 'sidebar.layer-group.name',
  //   router: {
  //     name: 'layer-group',
  //   },
  //   scopes: ['access:editor'],
  // },
  {
    icon: 'mdi-palette',
    trans: 'sidebar.style.name',
    router: {
      name: 'styles',
    },
    scopes: ['access:editor'],
  },
  {
    icon: 'mdi-database',
    text: 'Dữ liệu',
    router: { name: 'database' },
    model: true,
    scopes: ['access:admin'],
    children: [
      {
        icon: 'mdi-folder',
        trans: 'sidebar.workspace.name',
        router: {
          name: 'workspaces',
        },
        scopes: ['workspace-management'],
      },
      {
        icon: 'mdi-layers',
        trans: 'sidebar.layer.name',
        router: {
          name: 'layers',
        },
      },
      // {
      //   icon: 'mdi-map',
      //   trans: 'sidebar.layer-group.name',
      //   router: {
      //     name: 'layer-group',
      //   },
      // },
      {
        icon: 'mdi-palette',
        trans: 'sidebar.style.name',
        router: {
          name: 'styles',
        },
        scopes: ['style-management'],
      },
    ],
  },
  {
    icon: 'mdi-chart-line-variant',
    trans: 'sidebar.symbol.name',
    router: {
      name: 'symbol',
    },
    scopes: ['style-management'],
  },

  {
    icon: 'mdi-key',
    trans: 'sidebar.key.name',
    router: {
      name: 'keys',
    },
    scopes: ['key-management'],
  },
  {
    icon: 'mdi-sign-real-estate',
    text: 'Trạng thái hệ thống',
    scopes: ['access:admin'],
    router: { name: 'hethong' },
    model: false,
    children: [
      {
        icon: 'mdi-view-dashboard',
        text: 'Tổng quan',
        router: {
          name: 'system-summary',
        },
        scopes: ['system-summary'],
      },
      {
        icon: 'mdi-alert-rhombus-outline',
        text: 'File log lỗi',
        router: {
          name: 'log-errors',
        },
        scopes: ['log-file-errors-management'],
      },
      {
        icon: 'mdi-notebook',
        trans: 'sidebar.logs.name',
        router: {
          name: 'logs',
        },
        scopes: ['log-management'],
      },
    ],
  },
  {
    icon: 'mdi-backup-restore',
    text: 'Sao lưu',
    router: {
      name: 'backup',
    },
    scopes: ['backup-management'],
  },
  {
    icon: 'mdi-camera-iris',
    trans: 'sidebar.tasks.name',
    router: {
      name: 'tasks',
    },
  },
  {
    icon: 'mdi-monitor-dashboard',
    text: 'Giám sát vận hành',
    router: {
      name: 'monitor-dashboard',
    },
    scopes: ['access:admin'],
  },
]
